<template class="as-skeleton as-table-skeleton">
  <tr repeat.for="x of 5">
    <td class="${columnClassName}" repeat.for="columnClassName of columnClassNames">
      <div css="width: ${getRandomWidth()}%"></div>
    </td>
  </tr>
</template>
